export default {
  custom_allergen: {
    placeholder: 'Agregar opción personalizada',
  },
  buttons: {
    add: 'Agregar',
  },
};
